import { Vue } from './config'

if (document.getElementById('account')) {
    new Vue({
        el: '#account',
        components: {
        },
        data: {
            terms: terms,
            selectedTerm: terms[0]
        },
        computed: {
        },
        methods: {
            returnXMonthsTerm(x) {
                const filtered = terms.filter(term => {
                    if (term.Term === x) {
                        return true
                    }
                    return false;
                });
                if (filtered.length) {
                    return filtered[0];
                }
            }
        },
        mounted() {
            console.log(this.terms);
            this.selectedTerm = this.returnXMonthsTerm(12) ?? terms[0];
        }
    })
}